import type { ComponentProps, ReactNode } from 'react'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

/**
 * Los campos que shadcn no trae instalados (select y casilla) con la misma
 * pinta que Input: borde de --input, foco visible y etiqueta asociada.
 *
 * Se usan los nativos a proposito: un <select> del sistema se abre bien en el
 * telefono del inspector y no depende de ningun portal.
 */

export const CLASES_DE_CAMPO =
  'h-8 w-full rounded-md border border-input bg-background px-2 text-sm outline-none transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:opacity-50'

export function CampoConEtiqueta({
  etiqueta,
  htmlFor,
  ayuda,
  error,
  children,
}: {
  etiqueta: string
  htmlFor: string
  ayuda?: string
  error?: string
  children: ReactNode
}) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={htmlFor}>{etiqueta}</Label>
      {children}
      {ayuda !== undefined && error === undefined && (
        <p className="text-xs text-muted-foreground">{ayuda}</p>
      )}
      {error !== undefined && (
        <p className="text-xs text-destructive" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}

export function Selector({ className, ...props }: ComponentProps<'select'>) {
  return <select className={cn(CLASES_DE_CAMPO, className)} {...props} />
}

export function Casilla({ className, ...props }: ComponentProps<'input'>) {
  return (
    <input
      type="checkbox"
      className={cn(
        'size-4 rounded-sm border-input accent-primary outline-none focus-visible:ring-3 focus-visible:ring-ring/50',
        className,
      )}
      {...props}
    />
  )
}
